import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as rate from '../rate'

const page = prebuilt.Page.get(prebuilt.Page.Id.RateRules)

export const RESOURCE = {
  payload: {
    alias: 'rules',
    appAlias: rate.RESOURCE.payload.alias,
    description: page.description,
    display: {
      isMain: true,
      position: 0,
    },
    name: 'Rules',
    page: { id: prebuilt.Page.Id.RateRules },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
